/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HistoricalStatistics
 */
export interface HistoricalStatistics {
    /**
     * 
     * @type {number}
     * @memberof HistoricalStatistics
     */
    aum: number;
    /**
     * 
     * @type {number}
     * @memberof HistoricalStatistics
     */
    portfoliosNr: number;
    /**
     * 
     * @type {string}
     * @memberof HistoricalStatistics
     */
    tradeDate: string;
}

/**
 * Check if a given object implements the HistoricalStatistics interface.
 */
export function instanceOfHistoricalStatistics(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "aum" in value;
    isInstance = isInstance && "portfoliosNr" in value;
    isInstance = isInstance && "tradeDate" in value;

    return isInstance;
}

export function HistoricalStatisticsFromJSON(json: any): HistoricalStatistics {
    return HistoricalStatisticsFromJSONTyped(json, false);
}

export function HistoricalStatisticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoricalStatistics {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'aum': json['aum'],
        'portfoliosNr': json['portfolios_nr'],
        'tradeDate': json['trade_date'],
    };
}

export function HistoricalStatisticsToJSON(value?: HistoricalStatistics | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'aum': value.aum,
        'portfolios_nr': value.portfoliosNr,
        'trade_date': value.tradeDate,
    };
}

